export default {
  getPluginList: () => '/admin/plugin/list',
  getPluginInfo: () => '/admin/plugin/get',
  createPlugin: () => '/admin/plugin/create',
  modifyPlugin: () => '/admin/plugin/modify',
  deletePlugin: () => '/admin/plugin/delete',
  assignPluginToOrganization: () => '/admin/plugin/assign',
  getAssignedOUList: () => '/admin/plugin/organization/assigned/list',
  getOrganizationPluginList: () => '/admin/organization/plugin/list'
};
